import React from "react";

const SvgIconExternal = ({icon, extra = null, ...props}) => {
    return (
        <div className={extra ? extra : "svg-icon"} {...props}>
            <img src={icon} alt="."/>
        </div>
    )
}

export default React.memo(SvgIconExternal)
